/**
 * Display API date strings as MM-DD-YYYY without timezone conversion or time.
 * Avoids `new Date(...).toLocale*()` which shifts the wall-clock value.
 */
export function formatApiDate(value) {
  if (value == null || value === "") return "—";
  const raw = String(value).trim();
  const datePart = raw.split("T")[0] || raw.split(" ")[0];
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart);
  if (!match) return datePart || raw;
  const [, year, month, day] = match;
  return `${month}-${day}-${year}`;
}
